import { get, getWithPagination, patch, post, remove } from '@/api/base'

const companyUsersApi = {
  get: async companyUserUuid => {
    const response = await get({ path: `company_users/${companyUserUuid}` })
    return response.success ? response.data.company_user : null
  },
  getAll: async params => {
    const response = await get({
      path: 'company_users',
      params,
    })
    return response.success
      ? {
          companyUsers: response.data.company_users,
          pagination: response.data.meta.pagination,
        }
      : null
  },
  getWithPagination: async params => {
    const response = await getWithPagination({
      path: 'company_users',
      params,
      valuePath: 'company_users',
    })
    return response
  },
  create: async params => {
    const response = await post({
      path: 'company_users',
      params,
    })
    return response.success
  },
  delete: async companyUserUuid => {
    const response = await remove({
      path: `company_users/${companyUserUuid}`,
    })
    return response.success
  },
  update: async (companyUserUuid, params) => {
    const response = await patch({
      path: `company_users/${companyUserUuid}`,
      params,
    })
    return response.success ? response.data.company_user : null
  },
}

export default companyUsersApi
